import { Propriedade } from '../../@types';
import { Pluviometro } from '../../@types/pluviometro';
import { PluviometroToList } from './types';
import getSaveErrorMessage from '../../utils/error-message';

const messages = {
  descricao: {
    'já está em uso': 'Essa descrição já está em uso.',
    default: 'Descrição inválida.',
  },
};

export const getMessagesPluviometros = (
  error: unknown,
  status: 'create' | 'edit',
): string => getSaveErrorMessage(error, status, messages);

export const convertPluviometrosToList = (
  data: Pluviometro[],
  propriedadeList: Propriedade[],
) =>
  data.map<PluviometroToList>((pluviometro) => {
    const propriedade = propriedadeList.find(
      (item) => item.id === pluviometro.cdPropriedade,
    )!;

    return {
      ...pluviometro,
      status: pluviometro.stAtivo === 'S' ? 'Sim' : 'Não',
      propriedade,
    };
  });
